import { render, staticRenderFns } from "./SearchUnitsPage.vue?vue&type=template&id=4af508ee&"
import script from "./SearchUnitsPage.vue?vue&type=script&lang=js&"
export * from "./SearchUnitsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports